document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".shopify-section-header-sticky");

  if (!header) return;

  function updateHeader() {
    if (window.scrollY > 20) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  updateHeader();
  window.addEventListener("scroll", updateHeader);
});